<template>
	<c-modal @close="close" :title="'Uitloggen'">
		
		<p>Weet je zeker dat je wil uitloggen?</p>

		<div class="row collapse">
			<div class="columns">
				<button @click.prevent="logout" class="c-btn c-btn--primary c-btn--expanded no-margin-b margin-r-16">
					Uitloggen
				</button>
			</div>
			<div class="columns text-center">
				<button @click="close" class="c-btn c-btn--gray-600 c-btn--expanded c-btn--hollow no-margin-b margin-l-16">
					Annuleren
				</button>
			</div>
		</div>

	</c-modal>
</template>

<script>
import CModal from '@components/Modal';

export default {
	components: {
		CModal,
	},
	methods: {
		close() {
			this.$emit('close');
		},
		logout() {
			this.$store.dispatch('user/logout');
		}
	}
}
</script>